// test2028
(2028 && 0);
